module.exports = __webpack_public_path__ + "static/media/Thumbnail1.23861d17.jpeg";